import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class EditorSettingsService {
  private showCitationsSubject = new BehaviorSubject<boolean>(true)
  showCitations$ = this.showCitationsSubject.asObservable()

  get showCitations(): boolean {
    return this.showCitationsSubject.value
  }

  setShowCitations(value: boolean): void {
    this.showCitationsSubject.next(value)
  }

  private showWordCountSubject = new BehaviorSubject<boolean>(false)
  showWordCount$ = this.showWordCountSubject.asObservable()

  get showWordCount(): boolean {
    return this.showWordCountSubject.value
  }

  setShowWordCount(value: boolean): void {
    this.showWordCountSubject.next(value)
  }
}
